import orderHtml from './order.html';

class OrderController {
    constructor($scope, $timeout, $http, $state, orderService, translateService, ModalService) {
        'ngInject';

        this.service = orderService;
        this.products = [];
        this.file = null;
        this.allowedMimeTypes = ['cdr', 'svg', 'text/plain', 'image/svg+xml', 'application/cdr', 'application/coreldraw', 'application/x-cdr', 'application/x-coreldraw', 'application/vnd.corel-draw', 'image/cdr', 'image/x-cdr', 'image/x-coreldraw', 'zz-application/zz-winassoc-cdr'];
        this.allowedExtensions = ['cdr', 'svg'];
        this.errors = [];
        this.translate = translateService;
        this.saving = false;
        this.$http = $http;

        $scope.$watch(() => this.orderId, (newVal, oldVal) => {
            if (!newVal) {
                return;
            }

            this.updateOrderModels();
        });
    }

    updateOrderModels() {
        console.log('update order models');

        this.service.getOrderModels(this.orderId).then(
            (response) => {
                if (!response.data) {
                    this.products = [];

                    return false;
                }

                for (const product of response.data) {

                    if (product.adminProductionFile && product.adminProductionFileExtension === 'svg') {
                        product.adminProductionFile = window.atob(product.adminProductionFile);
                    }

                    if (product.type !== 'CartItemManually') {
                        continue;
                    }

                    if (product.productionFileExtension !== 'svg') continue;

                    product.productionFile = window.atob(product.productionFile);
                }

                console.log('OrderController::OrderController -> success', response.data);
                this.products = response.data;
            },
            (error) => {
                this.products = [];

                console.log('OrderController::OrderController -> error', error);
            }
        );
    }

    toggleReplace(product_id) {
        this.products.map((product) => {
            if (product.id == product_id) {
                product.replace = true;
            }
        });
    }

    validateProductFile(product_id) {
        delete this.errors[product_id];

        console.log(this.file.fileType);

        if (this.file && this.allowedMimeTypes.indexOf(this.file.fileType) == -1) {
            this.errors[product_id] = this.translate.t('configuratorManual.errors.invalidExtension', { allowedExtensions: 'CDR, SVG' });

            return;
        }

        if (this.file && this.file.fileSize > 10000240) {
            this.errors[product_id] = this.translate.t('configuratorManual.errors.maximumFileSize', { filesize: '10 MB' });

            return;
        }

        return true;
    }

    replaceProductFile(product_id) {
        this.saving = true;

        if (!this.validateProductFile(product_id)) {
            this.saving = false;

            return;
        }

        const form = new FormData();

        for (const product of this.products) {
            const { user_file_name, ...data } = product;

            console.log(product);
            console.log(user_file_name);
            console.log(data);

            form.append('products', JSON.stringify(data));

            if (user_file_name) {
                form.append('files[]', user_file_name.fileFormData.get('file'));
            } else {
                form.append('files[]', '-');
            }
        }

        this.$http.post('/user/configurator/manual/ajax/replaceProductProjectFile', form, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        }).then(
            (response) => {
                this.saving = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                }
            },
            () => {
                alert(this.translate.t('configuratorManual.errors.unexpected'));
                this.saving = false;
            }
        );
    }

    isTabletMode() {
        return (
            ((window.innerWidth <= 1280 && window.innerHeight <= 800) || (window.innerWidth <= 800 && window.innerHeight <= 1280))
            && 'ontouchstart' in window
        );
    }
}

let orderComponent = {
    bindings: {
        'orderId': '<'
    },
    template: orderHtml,
    controller: OrderController
};

export default orderComponent;